<template>
    <div
        data-testid="user-avatar"
        class="user-avatar fade rounded-full border-input box-border"
        :class="avatarClasses"
    >
        <img
            v-if="isCustomImage"
            class="rounded-full"
            :src="image"
            alt="avatar"
        />
        <BasicIcon
            v-else
            :inherit-fill="false"
            :size="computedIconSize"
            :name="image"
        />
    </div>
</template>

<script setup lang="ts">
import BasicIcon from '@atoms/BasicIcon/BasicIcon.vue';
import { sizesPx, type Size } from '@atoms/BasicIcon/sizes';
import { useListeners } from '@composables/useListeners';

const borderSize = 2;

export type UserAvatarProps = {
    image?: string;
    hover?: boolean;
    size?: Size;
};

const props = withDefaults(defineProps<UserAvatarProps>(), {
    image: 'avatar_user_menu',
    hover: true,
    size: '42',
});

const { hasAnyListener } = useListeners();

const avatarClasses = computed(() => {
    return {
        'cursor-pointer': hasAnyListener.value,
        'hover:border-primary': props.hover,
    };
});

const isCustomImage = computed(() => props.image !== 'avatar_user_menu');

const computedWrapperSize = computed(() => `${sizesPx[props.size]}px`);
const computedBorderSize = computed(() => `${borderSize}px`);
const computedIconSize = computed(
    () => `${sizesPx[props.size] - 2 * borderSize}` as Size
);
</script>

<style scoped>
.user-avatar {
    width: v-bind(computedWrapperSize);
    height: v-bind(computedWrapperSize);
    border-width: v-bind(computedBorderSize);
}
</style>
